import React, { forwardRef } from 'react';
import { Label } from '../ui/Typography';

interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  helperText?: string;
  fullWidth?: boolean;
}

const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ label, error, helperText, fullWidth = true, className = '', rows = 4, ...props }, ref) => {
    const baseClasses = `
      px-4 py-3
      bg-white dark:bg-gray-800
      border rounded-lg
      text-gray-900 dark:text-gray-100
      placeholder-gray-400 dark:placeholder-gray-500
      focus:ring-2
      focus:border-transparent
      transition-all
      duration-200
      resize-none
    `;

    const stateClasses = error
      ? 'border-red-300 focus:ring-red-500'
      : 'border-gray-300 dark:border-gray-600 focus:ring-primary-500';

    const widthClass = fullWidth ? 'w-full' : '';

    return (
      <div className={fullWidth ? 'w-full' : ''}>
        {label && (
          <Label className="mb-1">
            {label}
            {props.required && <span className="text-red-500 ml-1">*</span>}
          </Label>
        )}
        <textarea
          ref={ref}
          rows={rows}
          className={`
            ${baseClasses}
            ${stateClasses}
            ${widthClass}
            ${className}
          `}
          {...props}
        />
        {(error || helperText) && (
          <p className={`mt-1 text-sm ${error ? 'text-red-600' : 'text-gray-500'}`}>
            {error || helperText}
          </p>
        )}
      </div>
    );
  }
);

TextArea.displayName = 'TextArea';

export default TextArea;
